var _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import React from "react";
var SvgIconCheck = function SvgIconCheck(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "14px",
    viewBox: "0 0 19 14",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-884.000000, -82.000000)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(884.000000, 82.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2529183,0.00062918994 C16.8110425,0.013905126 16.3919123,0.1988118 16.0846893,0.516470553 L7.44428578,9.15687407 L2.80171352,5.48529731 C2.45086857,5.18564809 1.99287426,5.04247481 1.53390896,5.0870435 C1.07496793,5.13255892 0.653944281,5.36202943 0.367573431,5.72331258 C0.0812025814,6.08554246 -0.0458521806,6.54732364 0.0148350386,7.00531795 C0.0764714058,7.46236553 0.321111296,7.87484442 0.692832651,8.14793691 L6.51880569,12.7601656 C7.19393887,13.2940189 8.16209421,13.2390363 8.77180656,12.6312052 L18.4817616,2.92125016 C18.9862181,2.43385897 19.1388828,1.68665365 18.8667371,1.03994637 C18.5945913,0.394185806 17.9535886,-0.0192398056 17.2528454,0.000689877159 L17.2529183,0.00062918994 Z",
    id: "Fill-1"
  }))))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconCheck, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_check.2a83619a.svg";
export { ForwardRef as ReactComponent };